import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence, GoogleAuthProvider } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyAeIb8_r62JfTM8s83yQZVB-NFMz33nIFs",
  authDomain: "dance-studio-swg.firebaseapp.com",
  projectId: "dance-studio-swg",
  storageBucket: "dance-studio-swg.firebasestorage.app",
  messagingSenderId: "739611363685",
  appId: "1:739611363685:web:aa42d304c65da060ac798c"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const functions = getFunctions(app);
const projectId = firebaseConfig.projectId;
const realtimeDb = getDatabase();

// Ensure the user session persists across refresh
setPersistence(auth, browserLocalPersistence);

//export default db;

export { db, auth, googleProvider, functions, projectId, realtimeDb, httpsCallable};